import apiClient from "./config";
import { TICKETS_ENDPOINTS } from "./endpoints";

export const getTicketsList = () => apiClient.get(TICKETS_ENDPOINTS.GET_TICKETS_LIST);
export const addNewTicket = (ticket) => apiClient.create(TICKETS_ENDPOINTS.ADD_NEW_TICKET, ticket);
export const updateTicket = (ticket) => apiClient.update(TICKETS_ENDPOINTS.UPDATE_TICKET + '/' + ticket._id, ticket);
export const deleteTicket = (ticket) => apiClient.delete(TICKETS_ENDPOINTS.DELETE_TICKET + '/' + ticket);

